import { inject, Injectable } from '@angular/core';
import { StorageServiceKeysMap } from '@core/storage/types/storage.types';
import type { ResponseDeliveryTrackerCacheDto } from '@kerberos-compliance/compliance-shared-ts/features/delivery/dtos/response.delivery-tracker.cache-dto';
import { StorageService } from '@kerberos-compliance/compliance-shared-ui';

@Injectable({
  providedIn: 'root',
})
export class DeliveryTrackerPeriodsCacheService {
  private readonly storageService = inject(StorageService);

  /**
   * Reads the cached delivery tracker periods.
   *
   * @returns {ResponseDeliveryTrackerCacheDto[] | undefined} The cached periods, or undefined when nothing is cached.
   */
  public read(): ResponseDeliveryTrackerCacheDto[] | undefined {
    return this.storageService.get<ResponseDeliveryTrackerCacheDto[]>(
      StorageServiceKeysMap.DeliveryTrackerDetailPeriods,
    );
  }

  /**
   * Caches the given delivery tracker periods.
   *
   * @param {ResponseDeliveryTrackerCacheDto[]} periods - The periods to cache.
   * @returns {void} Does not return a value.
   */
  public write(periods: ResponseDeliveryTrackerCacheDto[]): void {
    this.storageService.set(StorageServiceKeysMap.DeliveryTrackerDetailPeriods, periods);
  }

  /**
   * Removes the cached delivery tracker periods.
   *
   * @returns {void} Does not return a value.
   */
  public clear(): void {
    this.storageService.remove(StorageServiceKeysMap.DeliveryTrackerDetailPeriods);
  }
}
